<template>
  <div class="sign-statistics">
    <div class="title">概况统计</div>
    <div class="overview-wrap">
      <div class="box">
        <p class="label">总签到用户数</p>
        <p class="value">{{ baseInfo.sign_user_num || 0 }}</p>
      </div>
      <div class="box">
        <p class="label">总签到次数</p>
        <p class="value">{{ baseInfo.sign_num || 0 }}</p>
      </div>
      <div class="box">
        <p class="label">人均签到次数</p>
        <p class="value">{{ baseInfo.average_sign_num || 0 }}</p>
      </div>
      <div class="box">
        <p class="label">订阅签到用户数</p>
        <p class="value">{{ baseInfo.sign_notice_num || 0 }}</p>
      </div>
    </div>
    <div class="title">详细数据</div>
    <div class="echarts-wrap">
      <RadioGroup class="btn-wrap" v-model="statisType" type="button">
        <Radio label="1">最近3天</Radio>
        <Radio label="2">最近7天</Radio>
        <Radio label="3">最近30天</Radio>
      </RadioGroup>
      <div ref="echarts" class="echarts"></div>
    </div>
  </div>
</template>

<script>
import ECharts from "echarts";
export default {
  name: "sign-statistics",
  data() {
    return {
      myECharts: null,
      statisType: "1",
      baseInfo: {}
    };
  },
  watch: {
    statisType() {
      this.requestEchartsData();
    }
  },
  mounted() {
    this.initECharts();
    this.requestBaseInfo();
    this.requestEchartsData();
  },
  methods: {
    // on event
    // other
    initECharts() {
      this.myECharts = ECharts.init(this.$refs.echarts);
      this.myECharts.setOption({
        grid: {
          left: 50,
          right: 50
          // bottom: 30
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            animation: false,
            label: {
              backgroundColor: "#505765"
            }
          }
        },
        legend: {
          left: 100,
          top: 10,
          orient: "horizontal",
          itemGap: 30,
          data: ["新签用户数", "签到用户数", "签到总次数"]
        },
        dataZoom: [
          {
            type: "slider",
            start: 0,
            end: 100,
            height: 8,
            borderColor: "transparent",
            backgroundColor: "#e2e2e2",
            handleIcon:
              "M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z", // jshint ignore:line
            handleSize: 20,
            handleStyle: {
              shadowBlur: 6,
              shadowOffsetX: 1,
              shadowOffsetY: 2,
              shadowColor: "#aaa"
            }
          },
          {
            type: "inside"
          }
        ],
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: [
          {
            type: "value",
            splitNumber: 8,
            min: 0,
            max: 16,
            name: "用户数"
          },
          {
            type: "value",
            splitNumber: 8,
            min: 0,
            max: 160,
            name: "签到次数"
          }
        ],
        series: [
          {
            name: "新签用户数",
            data: [],
            type: "bar",
            barWidth: 28,
            label: {
              show: true,
              position: "top",
              fontSize: 10
            },
            color: "#58e0FF"
          },
          {
            name: "签到用户数",
            data: [],
            type: "bar",
            barWidth: 28,
            label: {
              show: true,
              position: "top",
              fontSize: 10
            },
            color: "#1890FF"
          },
          {
            name: "签到总次数",
            type: "line",
            data: [],
            color: "#f00",
            yAxisIndex: 1,
            smooth: true
          }
        ]
      });
    },
    setECharts(option) {
      if (!this.myECharts) return;
      this.myECharts.setOption(option);
    },
    // request
    requestBaseInfo() {
      this.$http.get("/api/integral/sign/totalStatistics").then(data => {
        this.baseInfo = data;
      });
    },
    requestEchartsData() {
      this.$http
        .get("/api/integral/sign/statisticsDetail", {
          time_scope: this.statisType
        })
        .then(data => {
          // 寻找新签和签到用户数的最大值
          let userNumMax = 0;
          if (data.new_sign_user_num.length) {
            userNumMax = Math.max(...data.new_sign_user_num);
          }
          if (data.sign_user_num.length) {
            userNumMax = Math.max(userNumMax, Math.max(...data.sign_user_num));
          }
          // 寻找签到总次数最大值
          let totalNumMax = 0;
          if (data.sign_num.length) {
            totalNumMax = Math.max(...data.sign_num);
          }
          let tmpMax = Math.max(userNumMax, totalNumMax);
          this.setECharts({
            xAxis: {
              data: data.date
            },
            yAxis: [{ max: tmpMax }, { max: tmpMax }],
            series: [
              { data: data.new_sign_user_num },
              { data: data.sign_user_num },
              { data: data.sign_num }
            ]
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-statistics {
  .overview-wrap {
    margin-bottom: 20px;
    padding: 0 20px;
    .box {
      display: inline-block;
      border: 1px solid #c5c5c5;
      padding: 20px 0;
      text-align: center;
      width: 210px;
      height: 110px;
      margin-right: 70px;
      .label {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 20px;
      }
      .value {
        font-size: 16px;
      }
    }
  }
  .echarts-wrap {
    position: relative;
    .btn-wrap {
      position: absolute;
      // left: 920px;
      right: 50px;
      top: -40px;
    }
    .echarts {
      height: 580px;
      margin-bottom: 50px;
    }
  }
}
</style>
